import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectModal } from '../redux/selectors';
import { actionCloseModal } from '../redux/actions';


// TEMP RELOADING COMPONENT
const TempReloadingComponent = (props) => {
  useEffect(() => {
    if (typeof props.cb === 'function') {
      props.cb();
    }
  }, [props.cb]);
  return (<></>);
};


// DEFAULT COMPONENT
const Modal = (props) => {
  const dispatch = useDispatch();
  const modal = useSelector(selectModal);
  let jsx = null;
  let jsxTempReloading = null;

  const [reloading, setReloading] = useState(false);
  if (reloading) {
    const cbReloadingDone = () => {
      setReloading(false);
    }
    jsxTempReloading = (
      <TempReloadingComponent cb={cbReloadingDone} />
    );
  }

  /*
  // TODO
  useEffect(() => {
    // RELOAD (DISMOUNT THEN MOUNT) MODAL CONTENT when new content received
    setReloading(true);
  }, [modal.modalContent]);
  */

  const closeModal = () => {
    dispatch(actionCloseModal());
  };

  let cl = "modal-overlay";
  if (modal.animateOut === true) {
    cl += ' animate-close';
  }

  let without_x_button = false;
  if (modal.without_x_button === true) {
    without_x_button = true;
  }

  if (modal.modalContent !== false) {
    jsx = (
      <div className={cl}>
        <div className="modal-scrollable">
          <div className="fix-center-flex">
            <div className="flex-1"></div>

            <div className="modal">
              {
                without_x_button !== true && (
                  <>
                    <div className="modal-close" onClick={closeModal}><abbr title="Zatvori modal">×</abbr></div>
                    <div className="modal-close modal-close--left" onClick={closeModal}><abbr title="Zatvori modal">×</abbr></div>
                  </>
                )
              }
              {
                reloading === false ? (modal.modalContent) : (jsxTempReloading)
              }
            </div>

            <div className="flex-1"></div>
          </div>
        </div>
      </div>
    );
    document.body.classList.add('modal-opened');
  } else {
    document.body.classList.remove('modal-opened');
  }


  return (
    <>
      <div className="modal-container">
        {jsx}
      </div>
    </>
  );
};

export default Modal;